import { render } from "./AllDebtorsView.vue?vue&type=template&id=611c91eb"
import script from "./AllDebtorsView.vue?vue&type=script&lang=js"
export * from "./AllDebtorsView.vue?vue&type=script&lang=js"

import exportComponent from "E:\\doc\\projects\\copAccraCrusade\\cfan\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__